/**
 * usePopupDataProviders - Registers data providers for popup windows
 * 
 * This hook should be called once in the main app (e.g., MapComponents).
 * It registers callbacks that provide data when popups request it.
 * 
 * Note: Most data providers are now dedicated components that can use React Query hooks:
 * - PortTimelineDataProvider
 * - TargetsDataProvider (fetches ALL targets, not just current page)
 * - ReportShipDataProvider (fetches ship data for reports)
 * - ReportDataProvider (fetches job and template metadata)
 * - ArrivalsDataProvider
 * - EventsDataProvider
 * - VesselTimelineDataProvider
 */
import { useEffect } from 'react';
import { useSettings } from '../Settings/SettingsProvider';

export const usePopupDataProviders = (): void => {
  const { settings } = useSettings();

  // Helper to get common settings for popups (can be used by other providers)
  useEffect(() => {
    // Settings are now passed via individual data providers
    // This hook is kept for potential future shared functionality
  }, [settings]);
};
